import React, { useEffect, useState } from "react";
import RoomFacilitesTable from "./Components/RoomFacilitesTable";
import AddFacilites from "./Components/AddFacilites";
import EditFacilites from "./Components/EditFacilites";
import api from "../../../../../api/axios";
import Swal from "sweetalert2";

const RoomFacilitesList = () => {
  const [facilities, setFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  // ✅ Fetch all facilities
  const fetchFacilities = async () => {
    try {
      // setLoading(true);
      const res = await api.get(`/pms/amenities`);
      setFacilities(res.data.data || []);
    } catch (error) {
      console.error("Failed to fetch facilities:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFacilities();
  }, []);

  const handleDelete = async (id) => {
    await api.delete(`/pms/amenities/${id}`);
    fetchFacilities();
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Room Facilites List</h3>
            <div className="col-auto d-flex w-sm-100">
              <button
                type="button"
                className="btn btn-dark"
                data-bs-toggle="modal"
                data-bs-target="#add-facilites"
              >
                Add Facilites
              </button>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <RoomFacilitesTable
                data={facilities}
                loading={loading}
                onEdit={setSelectedFacility}
                onDelete={handleDelete}
              />
            </div>
          </div>
        </div>
      </div>
      <AddFacilites onAdded={fetchFacilities} />
      <EditFacilites facility={selectedFacility} onUpdated={fetchFacilities} />
    </div>
  );
};

export default RoomFacilitesList;
